"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFeather = require("react-feather");
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _loader = require("../loader");
var _FormContext = _interopRequireDefault(require("./FormContext"));
var _FormNumber = _interopRequireDefault(require("./FormNumber"));
var _Spinner, _CheckIcon;
const _excluded = ["onSave", "value", "onFocus", "onBlur", "readOnly", "enableDecimal"];
const FormEditableNumber = _ref => {
  let {
      onSave,
      value,
      onFocus,
      onBlur,
      readOnly,
      enableDecimal
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const {
    isFocus,
    onBlur: onInputBlur
  } = _react.default.useContext(_FormContext.default);
  const [saving, setSaving] = _react.default.useState(false);
  const [saved, setSaved] = _react.default.useState(false);
  const internalValueOptions = _react.default.useMemo(() => ({
    locked: isFocus
  }), [isFocus]);
  const [internalValue, setInternalValue] = (0, _arkReact.useInternalValueManager)(value ?? undefined, internalValueOptions);
  const lastValue = (0, _arkReact.usePrevious)(value ?? undefined);
  const savedHideTimeout = _react.default.useRef(null);

  // Unsubscribe to any event or async effect
  _react.default.useEffect(() => () => clearTimeout(savedHideTimeout?.current ?? undefined), [savedHideTimeout]);
  const handleInputChange = _react.default.useCallback(newValue => {
    setInternalValue(newValue);
    if (saved === true) setSaved(false);
  }, [saved]);
  const handleInputFocus = _react.default.useCallback(event => {
    setSaved(false);
    if (savedHideTimeout.current !== null) {
      clearTimeout(savedHideTimeout.current);
      savedHideTimeout.current = null;
    }
    if ((0, _ark.isFunction)(onFocus)) onFocus(event);
  }, [savedHideTimeout, onFocus]);
  const handleInputBlur = _react.default.useCallback(async (newValue, event) => {
    let notifiedValue = lastValue;
    let saveRequired = false;
    if (newValue != lastValue) {
      if (newValue == null) saveRequired = true;else saveRequired = (0, _ark.isValidNumber)(newValue);
    }
    if (saveRequired && (0, _ark.isFunction)(onSave)) {
      setSaving(true);
      try {
        const savedValue = await onSave(internalValue, event);
        if (savedValue !== undefined) {
          notifiedValue = savedValue;
          setSaved(true);
          savedHideTimeout.current = setTimeout(() => setSaved(false), 6000);
        }
      } catch {
        // Ignored
      }
      setSaving(false);
    }
    setInternalValue(notifiedValue);
    onInputBlur?.();
    onBlur?.(notifiedValue, event);
  }, [internalValue, lastValue, onSave, onBlur, setInternalValue]);
  const icon = _react.default.useMemo(() => {
    if (saving) return _Spinner || (_Spinner = /*#__PURE__*/_react.default.createElement(_loader.Spinner, {
      className: "formEditableLoadingIcon"
    }));
    if (saved) return _CheckIcon || (_CheckIcon = /*#__PURE__*/_react.default.createElement(_reactFeather.Check, {
      className: "formEditableSavedIcon"
    }));
    return null;
  }, [saved, saving]);
  const internalReadOnly = _react.default.useMemo(() => readOnly || saving, [readOnly, saving]);
  return /*#__PURE__*/_react.default.createElement(_FormNumber.default, (0, _extends2.default)({
    icon: icon,
    value: internalValue,
    readOnly: internalReadOnly,
    onChange: handleInputChange,
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    enableDecimal: enableDecimal,
    managed: true
  }, props));
};
process.env.NODE_ENV !== "production" ? FormEditableNumber.propTypes = {
  value: (0, _arkReact.propTypeAllowUndefined)(_ark.isValidNumber),
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  onSave: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func
} : void 0;
FormEditableNumber.defaultProps = {
  value: undefined,
  className: undefined,
  placeholder: undefined,
  readOnly: undefined,
  onSave: undefined,
  onFocus: undefined,
  onBlur: undefined
};
var _default = exports.default = FormEditableNumber;